<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-21 11:26:54
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-12 11:46:28
-->
<template>
	<div>
		<div
			v-if="Array.isArray(cellValue) && cellValue.length > 0"
			class="table-btns"
			:class="{
				'flex-row-align-center': column.mode === 'vertical',
				'flex-just-end': column.align === 'right',
				'flex-just-center': column.align === 'center',
			}"
			style="line-height: 20px"
		>
			<div
				v-for="(item, index) in btnArr.default"
				:key="index"
				:class="{
					'rowBtn pr-12': column.mode === 'vertical',
					'pl-12': column.mode === 'vertical' && index,
				}"
			>
				<component :is="(item.type && upperCase(`${item.type}Button`)) || defaultType" :item="item" :row="row" :row-index="rowIndex"></component>
			</div>
			<el-dropdown v-if="btnArr.more.length" :class="[column.mode === 'vertical' ? 'mt-2' : '']" @command="click">
				<span class="el-dropdown-link yx-color-primary cursor-pointer font-h4-regular flex-row flex-align-center">
					<span class="line mr-12" v-if="column.mode === 'vertical'"></span>
					<template v-if="column.moreType === 'ellipsis'">
						<i class="el-icon-more el-icon--right margin-0"></i>
					</template>
					<template v-else>
						<span>更多</span>
						<i class="el-icon-arrow-down el-icon--right margin-0"></i>
					</template>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item :command="item" v-for="(item, index) in btnArr.more" :key="index">
						<component :is="(item.type && upperCase(`${item.type}Button`)) || defaultType" :item="item" :row="row" :rowIndex="rowIndex"></component>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
		<div v-else><div class="yx-color-text-primary">-</div></div>
	</div>
</template>

<script>
import mixin from './mixin';
import Operaters from './operater';

export default {
	name: 'ButtonsCell',
	components: {
		...Operaters,
	},
	mixins: [mixin],
	data() {
		return {
			defaultType: 'TextButton',
		};
	},
	computed: {
		btnArr() {
			const limited = this.column?.custom?.limited || 4;
			const { cellValue = [] } = this;
			let btn1 = [];
			let more = [];
			if (cellValue.length === limited) {
				btn1 = cellValue;
			} else {
				btn1 = cellValue.slice(0, limited - 1);
				more = cellValue.slice(limited - 1);
			}
			return {
				default: btn1,
				more,
			};
		},
	},
	methods: {
		click(item) {
			if (item.click) {
				item.click(this.row, this.rowIndex);
			}
		},
		upperCase(str) {
			const [first] = str;
			if (first == first.toUpperCase()) return;
			return str.replace(/^\S/, s => s.toUpperCase());
		},
	},
};
</script>
<style lang="less" scoped>
.rowBtn {
	display: flex;
	align-items: center;
	height: 16px;
	& + & {
		border-left: 1px solid #eaebf0;
	}
	&:last-child {
		padding-right: 0 !important;
	}
}
.margin-0 {
	margin: 0;
}
/deep/.el-button--mini {
	padding: 5px 15px;
	font-weight: 400;
}
.line {
	height: 16px;
	width: 1px;
	background-color: #eaebf0;
	display: inline-block;
}
</style>
